import PropTypes from "prop-types";
import LoaderBar from "app/pages/.shared/LoaderBar/LoaderBar";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import MapIcon from "app/pages/.shared/static/icons/MapIcon";
import IconCross from "app/pages/.shared/static/icons/IconCross";
import "./MapToggleButton.scss";
import { FormattedMessage } from "react-intl";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import AppGlobalsContext from "app/AppGlobalsContext";
import { useContext } from "react";
import { connect } from "react-redux";

const MapToggleButton = ({ onClick = () => {}, showMap, isDisabled, googleAPIKey }) => {
	const { resolution } = useContext(AppGlobalsContext);

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	const showListLabel = isMobile ? (
		<FormattedMessage id="product.page.list.button.label" />
	) : (
		<FormattedMessage id="product.page.list.button.label.long" />
	);

	const showMapLabel = isMobile ? (
		<FormattedMessage id="product.page.map.button.label" />
	) : (
		<FormattedMessage id="product.page.map.button.label.long" />
	);

	if (!googleAPIKey) {
		return null;
	}

	return (
		<button
			type="button"
			className="map-toggle-button map-toggle-button__button-map"
			onClick={onClick}
			data-testid="toggle-map-button"
			disabled={isDisabled}
		>
			<div className="map-toggle-button__map">
				{showMap ? (
					<IconCross className="map-toggle-button__close-icon" />
				) : (
					<MapIcon className="map-toggle-button__map-icon" />
				)}
				{isDisabled ? (
					<LoaderBar height={12} width={125} />
				) : (
					<div className="map-toggle-button__map-label">
						<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
							{showMap ? showListLabel : showMapLabel}
						</Typography>
					</div>
				)}
			</div>
		</button>
	);
};

MapToggleButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	showMap: PropTypes.bool.isRequired,
	isDisabled: PropTypes.bool.isRequired,
	googleAPIKey: PropTypes.string,
};

const mapStateToProps = state => ({
	googleAPIKey: state.envVars.GOOGLE_API_KEY,
});

export default connect(mapStateToProps)(MapToggleButton);
